/**
 * Google Drive URL helpers.
 *
 * The API stores the raw `?export=download` URL copied from the import
 * sheet — this URL returns 403 when used as an <img src>. The public
 * thumbnail endpoint works without auth for files that are shared with
 * "anyone with the link".
 *
 *   Input:  https://drive.google.com/uc?id=FILE_ID&export=download
 *   Thumb:  https://drive.google.com/thumbnail?id=FILE_ID&sz=w<N>
 */

function extractDriveFileId(url: string): string | null {
  if (!url) return null;
  // Most common form: ?id=FILE_ID or &id=FILE_ID
  const qs = /[?&]id=([^&]+)/.exec(url);
  if (qs && qs[1]) return qs[1];
  // /file/d/FILE_ID/... form
  const path = /\/file\/d\/([^/?#]+)/.exec(url);
  if (path && path[1]) return path[1];
  return null;
}

/**
 * Size-parameterised Google Drive thumbnail. For non-Drive URLs returns
 * the original (safe to pass any URL).
 */
export function driveThumb(url: string | null | undefined, size = 1200): string {
  if (!url) return '';
  const id = extractDriveFileId(url);
  if (id) return `https://drive.google.com/thumbnail?id=${id}&sz=w${size}`;
  return url;
}
